import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import '../assets/css/icons.css';
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow, LICENSE } from "../../Server";
import axios from "axios";
import DashboardChart from "./siteChart";
import ChartistTooltip from "chartist-plugin-tooltips-updated";
import swal from "sweetalert";
import {
  CheckIcon,
  DashboardIcon,
  HomeIcon,
  UserIcon,
  UsersIcon,
  UserWhiteIcon,
  WorkflowIcon,
} from "../../assets/Icons";
import HeaderMobile from "../../common/HeaderMobile";
import { connect } from "react-redux";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {},
      loading: true,
    };
  }
  componentDidMount() {
    if (this.props?.user?.userDetails?.token) {
      this.init();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props?.user?.userDetails?.token != prevProps?.user?.userDetails?.token) {
      this.init();
    }
  }

  init() {
    this.SiteDashInfo();
    this.dataByLicense();
  }

  dataByLicense = () => {
    if (LICENSE.application_Dashboard) {
      this.setState(this.state);
    } else {
      setTimeout(() => {
        this.dataByLicense();
      }, 1000);
    }
  };
  SiteDashInfo = () => {
    const _groupId = this.props?.groupId;
    const _unoToken = this.props?.user?.userDetails?.token;

    var data = {
      groupId: _groupId,
      unoToken: _unoToken,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/dashboard/card/Values`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error == false) {
            _this.setState({ info: response.data, loading: false });
            return;
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.SiteDashInfo();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
        _this.setState({ loading: false });
      });
  };
  render() {
    const { user } = this.props;
    const { loading } = this.state;
    const { isMobile } = user;
    const userDetails = user.userDetails;

    return (
      <>
        {isMobile && <HeaderMobile />}
        <div className="xp-breadcrumbbar xp-heading breadcrumbnew">
          <div className="row">
            <div className="col-md-6 col-lg-6">
              <h4 className="xp-page-title">Dashboard</h4>
            </div>
            <div className="col-md-12 col-lg-12">
              <div className="xp-breadcrumb gradient-border">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <i>
                        <HomeIcon />{" "}
                      </i>
                    </a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {userDetails?.user?.group?.name}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="xp-contentbar snorth pr-3 pl-0 pt-0 teamdata">
          <div className="row">
            <div className="col-md-6 col-lg-6 col-xl-4">
              <div className="card ">
                <div className="card-body">
                  <div className="xp-widget-box">
                    <div>
                      {loading ? (
                        <div className="skeleton" style={{ height: "1.5rem", width: "3rem" }} />
                      ) : (
                        <h4 className="xp-counter">{this.state.info.totalUsers}</h4>
                      )}
                      <p className="mb-0 font-15">Total Users</p>
                    </div>
                    <div className="xp-widget-icon xp-widget-icon-bg">
                      <i>
                        <UsersIcon />
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-md-6 col-lg-6 col-xl-3">
                     <div className="card m-b-30">
                       <div className="card-body">
                         <div className="xp-widget-box ">
                           <div>
                             <h4 className="xp-counter">{this.state.info.activeUsers}</h4>
                             <p className="mb-0 font-12 "> Active Users</p>
                           </div>
                           <div className="xp-widget-icon xp-widget-icon-bg">
                             <i>
                               <UserWhiteIcon />
                             </i>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div> */}

            <div className="col-md-6 col-lg-6 col-xl-4">
              <div className="card m-b-30">
                <div className="card-body">
                  <div className="xp-widget-box">
                    <div>
                      {loading ? (
                        <div className="skeleton" style={{ height: "1.5rem", width: "3rem" }} />
                      ) : (
                        <h4 className="xp-counter">{this.state.info.totalWorkflows}</h4>
                      )}
                      <p className="mb-0 font-15">Total Workflows</p>
                    </div>
                    <div className="xp-widget-icon xp-widget-icon-bg">
                      <i>
                        <WorkflowIcon />
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-4">
              <div className="card m-b-30">
                <div className="card-body">
                  <div className="xp-widget-box">
                    <div>
                      {loading ? (
                        <div className="skeleton" style={{ height: "1.5rem", width: "3rem" }} />
                      ) : (
                        <h4 className="xp-counter">{this.state.info.totaLiveWorkflows}</h4>
                      )}
                      <p className="mb-0 font-15">Live Workflows</p>
                    </div>
                    <div className="xp-widget-icon xp-widget-icon-bg">
                      <i style={{ fontSize: "20px", marginTop: "11px" }}>
                        <CheckIcon />{" "}
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* {LICENSE.application_Dashboard ? (
                   LICENSE.application_Dashboard.enable_analytics == 1 ? ( */}

          <DashboardChart
            no_Workflow={[this.state.info.totalWorkflows]}
            totaLiveWorkflows={this.state.info.totaLiveWorkflows}
            loading={this.state.loading}
            groupId={this.props.groupId}
          />

          {/* ) : (
                     <span className="text-danger"> Analytics is not part of the current license.</span>
                   )
                 ) : null} */}
        </div>
      </>
    );
  }
}
// export default Dashboard

const mapStateToProps = (state) => ({
  user: state.userData,
});

export default connect(mapStateToProps)(Dashboard);
